"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = initSeemple;

var _defs = _interopRequireDefault(require("./defs"));

var objectId = 0; // this is common function which associates an object with its Seemple definition

function initSeemple(object) {
  var def = _defs["default"].get(object);

  if (!def) {
    def = {
      // a property name of "events" object is an event name
      // and a value is an array of event handlers
      events: {
        /* example: {
                    callback: function,
                    ctx: object,
                    context: object2,
                    name: "example",
                    info: { ...extra data for an event... }
                } */
      },
      // "props" contains special information about properties (getters, setters etc)
      props: {
        /* example: {
                    value: object[key],
                    mediator: null,
                    bindings: [{
                        node,
                        binder,
                        nodeHandler,
                        objectHandler,
                        ...other required info
                    }]
                } */
      },
      id: objectId
    };
    objectId += 1;

    _defs["default"].set(object, def);

    if (object._afterInit) {
      object._afterInit(def);
    }
  }

  return def;
}
//# sourceMappingURL=init.js.map